class ZoomImage extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		const images = Array.from(this.querySelectorAll('img'));
		const pagination = this.querySelector('.zoom-pagination');
		const previousButton = pagination?.querySelector('.zoom-previous');
		const nextButton = pagination?.querySelector('.zoom-next');
		const counter = pagination?.querySelector('.zoom-counter span');

		if (!images.length || !pagination) return;

		images.forEach((image) => {
			image.style.transition = 'transform 0.2s ease-out';
			image.style.transformOrigin = 'center center';

			let isZoomed = false;

			function toggleZoom(event) {
				event.preventDefault();
				if (isZoomed) {
					resetZoom();
				} else {
					applyZoom(event);
				}
				isZoomed = !isZoomed;
			}

			function applyZoom(event) {
				const rect = image.getBoundingClientRect();
				let x = 0;
				let y = 0;

				if (event.type.startsWith('touch')) {
					const touch = event.touches[0] || event.changedTouches[0];
					x = touch.pageX - rect.left - window.pageXOffset;
					y = touch.pageY - rect.top - window.pageYOffset;
				} else {
					x = event.clientX - rect.left;
					y = event.clientY - rect.top;
				}

				const xPercent = (x / rect.width) * 100;
				const yPercent = (y / rect.height) * 100;

				image.style.transformOrigin = `${xPercent}% ${yPercent}%`;
				image.style.transform = 'scale(2)';
			}

			function resetZoom() {
				image.style.transformOrigin = 'center center';
				image.style.transform = 'scale(1)';
			}

			image.addEventListener('click', toggleZoom);
			image.addEventListener('touchstart', toggleZoom);
		});

		if (!images.find((img) => img.classList.contains('active'))) {
			images[0].classList.add('active');
		}
		updateCounter();

		function updateCounter() {
			const currentIndex = images.findIndex((img) => img.classList.contains('active'));
			counter.textContent = currentIndex + 1;
		}

		function navigateImages(direction) {
			const currentIndex = images.findIndex((img) => img.classList.contains('active'));
			if (currentIndex === -1) return;
			images[currentIndex].classList.remove('active');
			let newIndex;
			if (direction === 'next') {
				newIndex = (currentIndex + 1) % images.length;
			} else if (direction === 'previous') {
				newIndex = (currentIndex - 1 + images.length) % images.length;
			}
			images[newIndex].classList.add('active');
			updateCounter();
		}

		previousButton?.replaceWith(previousButton.cloneNode(true));
		nextButton?.replaceWith(nextButton.cloneNode(true));
		const newPreviousButton = pagination.querySelector('.zoom-previous');
		const newNextButton = pagination.querySelector('.zoom-next');
		newPreviousButton?.addEventListener('click', (event) => {
			event.preventDefault();
			event.stopPropagation();
			navigateImages('previous');
		});

		newNextButton?.addEventListener('click', (event) => {
			event.preventDefault();
			event.stopPropagation();
			navigateImages('next');
		});
	}
}

customElements.get('zoom-image') || customElements.define('zoom-image', ZoomImage);
